import type { NetworkPayload } from "../../../composites";

export const API = {
  fetchOrganizationUsers: (orgId: API.OrganizationId): NetworkPayload => {
    return {
      url: `organizations/${orgId}/users`,
      options: {
        method: "GET",
      },
    };
  },
};
